var _path, _path2, _path3, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5612 29.1224C22.6031 29.1224 29.1224 22.6031 29.1224 14.5612C29.1224 6.51927 22.6031 0 14.5612 0C6.51927 0 0 6.51927 0 14.5612C0 22.6031 6.51927 29.1224 14.5612 29.1224Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5613 26.4008C21.1 26.4008 26.4006 21.1002 26.4006 14.5615C26.4006 8.02281 21.1 2.72217 14.5613 2.72217C8.0226 2.72217 2.72195 8.02281 2.72195 14.5615C2.72195 21.1002 8.0226 26.4008 14.5613 26.4008Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0092 16.635V19.6261C11.0092 19.8309 10.8309 20 10.6081 20H10.4011C10.1815 20 10 19.8338 10 19.6261V10C10.0446 10 10.086 10 10.1305 10C13.3111 10 16.4916 10 19.6721 10C19.7262 10 19.7835 10.003 19.8376 10.0148C19.9777 10.0504 20.0414 10.1721 19.9714 10.2878C19.7135 10.724 19.4492 11.1602 19.185 11.5935C18.8539 12.1365 18.5228 12.6795 18.1853 13.2196C18.1375 13.2938 18.1439 13.3472 18.1885 13.4184C18.752 14.3412 19.3091 15.2671 19.8695 16.1899C19.965 16.3472 19.9491 16.4659 19.8122 16.5875C19.7867 16.6113 19.7485 16.6231 19.7135 16.632C19.6785 16.638 19.6434 16.635 19.6052 16.635C16.7972 16.635 13.9892 16.635 11.1812 16.635C11.1302 16.635 11.0793 16.635 11.0092 16.635Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.6703,
    y1: 25.5659,
    x2: 14.6703,
    y2: 35.6788,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceMarker);
export default __webpack_public_path__ + "static/media/placeMarker.38f072041838709231f3df26f89dd405.svg";
export { ForwardRef as ReactComponent };